import {SurgeryBooked} from 'domain/usecases';
import {DateFormatEnum} from 'presentation/constants';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {formatAddress, formatDateString} from 'presentation/utils';
import {ParsedSurgeryAppointment} from './types';

export const parseSurgeryAppointments = (
	agendamentosCirurgicos: SurgeryBooked[],
): ParsedSurgeryAppointment[] =>
	agendamentosCirurgicos.map(item => {
		return {
			bookingNumber: item.nuConsulta?.toString(),
			specialtyCode: '',
			subSpecialtyCode: '',
			specialtyName: item?.nmCirurgia ?? '',
			clinicName: item.nmPrestadorJuridico,
			providerName: item.nmPrestadorFisico,
			bookingType: BookingTypeEnum.SURGERY,
			formattedAddress: formatAddress({
				type: item.tipoLogradouro,
				state: item.cdUf,
				city: item.nmCidade,
				number: item.numero?.toString(),
				address: item.logradouro,
				district: item.bairro,
				reference: item.pontoReferencia,
			}),
			date: formatDateString(item.dtConsulta, DateFormatEnum.DATE_FORMAT_14, 'P HH:mm'),
			dateOnly: formatDateString(
				item.dtConsulta,
				DateFormatEnum.DATE_FORMAT_14,
				DateFormatEnum.DATE_FORMAT_8,
			),
			hour: formatDateString(item.dtConsulta, DateFormatEnum.DATE_FORMAT_14, 'HH:mm'),
			formattedDateWithWeekday: formatDateString(
				item.dtConsulta,
				DateFormatEnum.DATE_FORMAT_14,
				'EEEE, dd/MM/yy',
			),
			telehealthUrl: '',
			protocolNumber: item.nuProtocolo,
			isConfirmed: item.confirmado,
			phoneNumbers: [],
			email: '',
			phone: '',
		};
	});
